// TODO ISO 27001: confirmar con back todos los valores posibles de
// gateESHistoStatusCode y gateESHistoSemaforo para mapeo completo.

import React from "react";
import { toast } from "sonner";
import { Entrada, Salida, InOut } from "assets/icons";
import { Close } from "@mui/icons-material";

const SVG_ACTION = { E: Entrada, S: Salida, A: InOut };

const COLOR_BARRA = {
    E: "#4caf50",
    S: "#ff0000",
    A: "#0369a1",
};

const COLOR_TEXTO = {
    A: "#000",
    V: "#EEE"
}

// Fondos oscuros para garantizar legibilidad del texto blanco
const BACKGROUND_POR_ESTADO = {
    V: "#15803d",   // green-700
    A: "#f9e37c",   // amber-700
    R: "#b91c1c",   // red-700
    B: "#374151",   // gray-700
};

const BORDER_POR_ESTADO = {
    V: "#16a34a",   // green-600
    A: "#ff9822",   // amber-600
    R: "#dc2626",   // red-600
    B: "#4b5563",   // gray-600
};

// ** sacamos el mock cuando el back mande gateESHistoSemaforo en el detalle
const ESTADOS_POSIBLES = ["V", "A"];

export default function MonitorToast({ t, detalle }) {
    const {
        usuarioApellidos,
        usuarioNombres,
        gateESHistoFH,
        gateLugarNombre,
        gateESHistoStatusCode,
        usuarioNroDeDocumentoX,
        gateESHistoSemaforo,
    } = detalle;

    const nombreCompleto = `${usuarioApellidos}, ${usuarioNombres}`;
    const hora = gateESHistoFH?.slice(0, 5) ?? "";
    const SvgIcon = SVG_ACTION[gateESHistoStatusCode] ?? null;
    const colorBarra = COLOR_BARRA[gateESHistoStatusCode] ?? "#9ca3af";

    // ** fallback random cuando no llegue gateESHistoSemaforo del back
    const estadoFinal = gateESHistoSemaforo
        ?? ESTADOS_POSIBLES[Math.floor(Math.random() * ESTADOS_POSIBLES.length)];
    const colorTexto = COLOR_TEXTO[estadoFinal] ?? "#fff";

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            background: `${BACKGROUND_POR_ESTADO[estadoFinal] ?? "#374151"}`,
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 9px 26px rgba(0,0,0,0.22)",
            border: `2px solid ${BORDER_POR_ESTADO[estadoFinal] ?? "#4b5563"}`,
            borderLeft: "none",
            width: "580px",
            gap: "18px",
            position: "relative",
            overflow: "hidden",
        }}>
            <div style={{
                position: "absolute",
                left: 0, top: 0, bottom: 0,
                width: "9px",
                backgroundColor: colorBarra,
            }} />

            <div style={{ display: "flex", flexDirection: "column", flex: 1, paddingLeft: "9px" }}>
                <span style={{ fontSize: "22px", fontWeight: "600", color: colorTexto }}>
                    {nombreCompleto}
                </span>
                <span style={{ fontSize: "17px", color: colorTexto, marginTop: "3px" }}>
                    DNI: {usuarioNroDeDocumentoX}
                </span>

                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginTop: "12px", gap: "10px" }}>
                    {hora && (
                        <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "17px", fontWeight: "600", color: colorTexto }}>
                            {SvgIcon && (
                                <img src={SvgIcon} alt={gateESHistoStatusCode} style={{ width: 18, height: 18 }} />
                            )}
                            {hora}
                        </span>
                    )}
                    {gateLugarNombre && (
                        <span style={{
                            fontSize: "15px",
                            fontWeight: "500",
                            color: colorTexto,
                            backgroundColor: "rgba(255,255,255,0.18)",
                            padding: "5px 11px",
                            borderRadius: "18px",
                        }}>
                            📍 {gateLugarNombre}
                        </span>
                    )}
                </div>
            </div>

            <button
                type="button"
                onClick={() => toast.dismiss(t)}
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "rgba(255,255,255,0.6)",
                    padding: "4px",
                    alignSelf: "flex-start",
                    fontSize: "20px",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.6)")}
            >
                <Close fontSize="inherit" />
            </button>
        </div>
    );
}